import api from 'Api';

export class EngineConfigurationService {
  async getGoogleClientId () {
    let response = await api.get('/portals/engineConfigurations', {
      params: {
        type: 1
      }
    });
    return response.data.data[0].appId;
  }

  async getFacebookAppId () {
    let response = await api.get('/portals/engineConfigurations', {
      params: {
        type: 5
      }
    });
    return response.data.data[0].appId;
  }

  async getShopifyAppId (portalId) {
    let response = await api.get(`/portals/${portalId ? portalId + '/' : ''}engineConfigurations`, {
      params: {
        type: 24
      }
    });
    return response.data.data;
  }
}